export default __webpack_public_path__ + "static/model360-london-304beaab4d5026ac3d4a686fda44ba33.png";